import { ComponentType } from 'react';

import Loadable from '@townsquare/loadable';
import { RouteContext } from '@townsquare/router/routing-types';

export const StatusUpdatesView: ComponentType<RouteContext> & LoadableExport.LoadableComponent =
	Loadable({
		loader: () => import(/* webpackChunkName: "StatusUpdatesView" */ './StatusUpdates'),
		loading: () => null,
	});
